import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Navbar } from '../components/Navbar'
import { SiteFooter } from '../sections/SiteFooter'
import { FadeIn } from '../components/ui/FadeIn'
import { GlassCard } from '../components/ui/GlassCard'
import { Lock } from 'lucide-react'
import { useLanguage } from '../contexts/LanguageContext'

export function PrivacyPolicyPage() {
  const { t } = useLanguage()
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-nexus-black text-white">
      <Navbar />
      <main className="pt-16 pb-16 sm:pt-20 lg:pt-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-8"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="grid size-12 place-items-center rounded-xl bg-white/10 border border-white/10">
                <Lock className="size-6 text-nexus-blue" />
              </div>
              <div>
                <div className="text-xs font-semibold tracking-[0.2em] text-nexus-blue/80">
                  {t('legal.privacy.label')}
                </div>
                <h1 className="mt-2 text-3xl font-semibold tracking-tight sm:text-4xl">
                  {t('legal.privacy.title')}
                </h1>
              </div>
            </div>
            <p className="text-white/70 mt-4">
              {t('legal.privacy.lastUpdated')}
            </p>
          </motion.div>

          <div className="space-y-8">
            {[
              {
                titleKey: 'legal.privacy.section1.title',
                contentKey: 'legal.privacy.section1.content',
              },
              {
                titleKey: 'legal.privacy.section2.title',
                contentKey: 'legal.privacy.section2.content',
              },
              {
                titleKey: 'legal.privacy.section3.title',
                contentKey: 'legal.privacy.section3.content',
              },
              {
                titleKey: 'legal.privacy.section4.title',
                contentKey: 'legal.privacy.section4.content',
              },
              {
                titleKey: 'legal.privacy.section5.title',
                contentKey: 'legal.privacy.section5.content',
              },
            ].map((section, index) => (
              <FadeIn key={section.titleKey} delay={0.1 * index}>
                <GlassCard>
                  <h2 className="text-xl font-semibold mb-4">{t(section.titleKey)}</h2>
                  <div className="text-white/70 space-y-3 leading-relaxed">
                    {t(section.contentKey)
                      .split('\n')
                      .map((paragraph, pIndex) => (
                        <p key={pIndex}>{paragraph}</p>
                      ))}
                  </div>
                </GlassCard>
              </FadeIn>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  )
}

